var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 46,
    viewBox: "0 0 41 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_5462_7003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6C4.5 3.79086 6.29086 2 8.5 2H24.5L36.5 14V38C36.5 40.2091 34.7091 42 32.5 42H8.5C6.29086 42 4.5 40.2091 4.5 38V6Z",
    fill: "#BEAF87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.5 2L36.5 14H28.5C26.2909 14 24.5 12.2091 24.5 10V2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1666 22.6667L20.4229 21.1793C20.2089 20.7512 20.1018 20.5372 19.9422 20.3808C19.801 20.2425 19.6308 20.1373 19.444 20.0729C19.2327 20 18.9934 20 18.5148 20H15.9666C15.2198 20 14.8465 20 14.5613 20.1453C14.3104 20.2732 14.1064 20.4771 13.9786 20.728C13.8333 21.0132 13.8333 21.3866 13.8333 22.1333V22.6667M13.8333 22.6667H23.9666C25.0867 22.6667 25.6467 22.6667 26.0746 22.8847C26.4509 23.0764 26.7569 23.3824 26.9486 23.7587C27.1666 24.1865 27.1666 24.7466 27.1666 25.8667V28.8C27.1666 29.9201 27.1666 30.4802 26.9486 30.908C26.7569 31.2843 26.4509 31.5903 26.0746 31.782C25.6467 32 25.0867 32 23.9666 32H17.0333C15.9131 32 15.3531 32 14.9253 31.782C14.5489 31.5903 14.243 31.2843 14.0512 30.908C13.8333 30.4802 13.8333 29.9201 13.8333 28.8V22.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_5462_7003",
    x: -2.5,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5462_7003"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5462_7003",
    result: "effect2_dropShadow_5462_7003"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5462_7003",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.7a38ac9657c3c342c6551ce2b66e092c.svg";
export { ForwardRef as ReactComponent };